/* eslint-disable consistent-return */
import React from 'react'

class Progress extends React.Component {
  static defaultProps = {
    completed: 0,
    color: '#2AA955', // '#F38323' , '#9D2151'
    animation: 200,
    height: 8,
  }

  static throwError() {
    // eslint-disable-next-line prefer-rest-params
    // biome-ignore lint/complexity/noArguments: TODO
    return new Error(...arguments)
  }

  render() {
    const { color, completed, animation, height, className, children, ...rest } = this.props

    const style = {
      backgroundColor: color,
      width: `${completed}%`,
      transition: `width ${animation}ms`,
      height,
      borderRadius: '10px',
    }

    const containerStyle = {
      backgroundColor: '#D8D8D8',
      width: '100%',
      height,
      borderRadius: '10px',
    }

    return (
      <div className={className || 'progressbar-container'} {...rest} style={containerStyle}>
        <div className="progressbar-progress" style={style}>
          {children}
        </div>
      </div>
    )
  }
}

export default Progress
